import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalUserProfile from '../../../../../stores/global-user-profile';

export const studentAssignmentDeleteOperation = async (
  programId: number,
  courseId: number,
  assignmentId: number,
  setDeleteFileLoading: (loading: boolean) => void,
) => {
  try {
    const studentId = globalUserProfile.userProfile.userWithRole?.id;

    if (!studentId) {
      toast.warn('לא ניתן לאתר את מזהה הסטודנט, נסה שוב בעוד מספר רגעים...');
      return;
    }

    setDeleteFileLoading(true);

    await appApi.deleteStudentAssignmentFile(
      programId,
      courseId,
      assignmentId,
      studentId,
    );

    // Refresh the user profile to get updated assignment data
    await globalUserProfile.getUserProfile();

    toast.success('הקובץ נמחק בהצלחה');
  } catch (e) {
    toast.error('מחיקת הקובץ נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `studentAssignmentDeleteOperation failed with programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId}, error: ${e}`,
    );
  } finally {
    setDeleteFileLoading(false);
  }
};
